/**
 * /client-workroom — Surface Layer (/01), UserHub.
 *
 * REQ-001.63 SCAFFOLD. Mounts the UserHub Client Workroom MVP (one Cestari
 * Studio client, no spoke). Navigable skeleton + mock data only — local
 * preview, not production. See `features/client-workroom/ClientWorkroom.tsx`.
 */

import { createFileRoute } from '@tanstack/react-router';
import { ClientWorkroom } from '../features/client-workroom/ClientWorkroom';

export const Route = createFileRoute('/client-workroom')({
  component: ClientWorkroom,
});
